import '../../components/Menu.scss';

import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonMenuToggle } from '@ionic/react';
import { helpCircle } from 'ionicons/icons';
import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { contactLink, jettingCalculatorLink, productInformationLink, trainingLink } from 'src/constants';
import { GenericMessages } from 'src/intl/GenericMessages';
import sentinelLogo from '../../assets/images/SentinelLogo.png';
import { useDispatch, useSelector } from 'react-redux';
import { selectSideMenuOpen } from 'src/redux/common/selectors';
import { commonActions } from 'src/redux/common/actions';

const externalResourceLinks = [jettingCalculatorLink, productInformationLink, trainingLink];

export const JobReportGuestMenu: React.FC = () => {
  const { formatMessage } = useIntl();
  const menuRef = useRef<HTMLIonMenuElement>(null);
  const isSideMenuOpen = useSelector(selectSideMenuOpen);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSideMenuOpen) {
      menuRef?.current?.open();
    } else {
      menuRef?.current?.close();
    }
  }, [isSideMenuOpen]);

  return (
    <IonMenu
      onIonDidClose={() => dispatch(commonActions.toggleSideMenu())}
      ref={menuRef}
      side="start"
      menuId="first"
      contentId="main"
      className="root-menu"
      swipeGesture={false}
    >
      <IonContent>
        <IonList id="sentinel-link">
          <IonListHeader>
            <img
              src={sentinelLogo}
              alt="stoneage logo"
              style={{
                maxHeight: '50px',
                width: 'auto',
                marginRight: '1em',
              }}
            />
            {formatMessage(GenericMessages.sentinelLink)}
          </IonListHeader>
          <IonItem slot="header">
            <IonLabel>{formatMessage(GenericMessages.externalLinks)}</IonLabel>
          </IonItem>

          <div slot="content">
            <IonList>
              {externalResourceLinks.map((link, index) => (
                <IonMenuToggle key={`${link.title}-${index}`} autoHide={false}>
                  <IonItem
                    lines="none"
                    href={link.actionUrl}
                    target="_blank"
                    data-testid={`navTile-${link.automationId}`}
                  >
                    <IonIcon slot="start" icon={link.icon} color="dark" />
                    <IonLabel>{formatMessage(link.title)}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              ))}
              <IonMenuToggle autoHide={false}>
                <IonItem
                  lines="none"
                  href={contactLink.actionUrl}
                  target="_blank"
                  data-testid={`menuItem-${contactLink.automationId}`}
                >
                  <IonIcon slot="start" icon={helpCircle} color="dark" />
                  <IonLabel>{formatMessage(contactLink.title)}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            </IonList>
          </div>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};
